import { render, staticRenderFns } from "./MouldForm.vue?vue&type=template&id=f58b437c&scoped=true&"
import script from "./MouldForm.vue?vue&type=script&lang=js&"
export * from "./MouldForm.vue?vue&type=script&lang=js&"
import style0 from "./MouldForm.vue?vue&type=style&index=0&id=f58b437c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58b437c",
  null
  
)

export default component.exports